import Quill from 'quill'

/**
 * O blot nativo de imagem do Quill só rastreia alt/height/width — um atributo style
 * (usado pelo bloco de assinatura pra float:left) seria descartado ao salvar/recarregar.
 * Esta extensão passa a rastrear style também, sem mexer no resto do comportamento nativo.
 */
const ImageBase: any = Quill.import('formats/image')

export default class ImageComEstilo extends ImageBase {
  static formats(node: HTMLElement) {
    const formats = ImageBase.formats(node)

    if (node.hasAttribute('style')) {
      formats.style = node.getAttribute('style')
    }

    return formats
  }

  format(name: string, value: string) {
    if (name === 'style') {
      if (value) {
        this.domNode.setAttribute('style', value)
      } else {
        this.domNode.removeAttribute('style')
      }
      return
    }

    super.format(name, value)
  }
}

ImageComEstilo.blotName = 'image'
ImageComEstilo.tagName = 'IMG'

Quill.register(ImageComEstilo, true)
